import React, { useState } from 'react';
import { Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import moment from 'moment';

import { partial } from '../../../util/translation/translation';

import Loading from '../../../shared/components/custom/Loading';
import StatisticsOverview from './StatisticsOverview';
import TopCompaniesList from './TopCompaniesList';
import RecentActivities from './RecentActivities';

const s = partial('shared');

const SummaryList = () => {
  const [loading, setLoading] = useState(false);
  const [topCompaniesLoading, setTopCompaniesLoading] = useState(false);
  const [dealsStatisticsLoading, setDealsStatisticsLoading] = useState(false);
  const [startEndObject, setStartEndObject] = useState({
    start: null,
    end: null,
    type: 'allTime',
  });
  const handleStartEnd = (filter) => {
    let internal = {
      start: null,
      end: null,
      type: filter,
    };
    switch (filter) {
      case 'allTime':
        internal.start = null;
        internal.end = null;
        break;
      case 'thisYear':
        internal.start = moment().startOf('year').toISOString();
        internal.end = moment().endOf('year').toISOString();
        break;
      case 'lastYear':
        internal.start = moment()
          .subtract(1, 'year')
          .startOf('year')
          .toISOString();
        internal.end = moment().subtract(1, 'year').endOf('year').toISOString();
        break;
      default:
        internal.start = null;
        internal.end = null;
        break;
    }
    setStartEndObject(internal);
  };

  return (
    <>
      <Loading
        loading={loading || topCompaniesLoading || dealsStatisticsLoading}
      />
      <Nav pills>
        <NavItem>
          <NavLink
            role="button"
            onClick={() => handleStartEnd('allTime')}
            active={startEndObject.type === 'allTime'}
          >
            {s('allTime')}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            role="button"
            onClick={() => handleStartEnd('thisYear')}
            active={startEndObject.type === 'thisYear'}
          >
            {s('thisYear')}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            role="button"
            onClick={() => handleStartEnd('lastYear')}
            active={startEndObject.type === 'lastYear'}
          >
            {s('lastYear')}
          </NavLink>
        </NavItem>
      </Nav>
      <StatisticsOverview
        setLoading={setDealsStatisticsLoading}
        startEndObject={startEndObject}
      />
      <Row className="mb-3">
        <Col md={6}>
          <TopCompaniesList
            setLoading={setTopCompaniesLoading}
            startEndObject={startEndObject}
          />
        </Col>
        <Col md={6}>
          <RecentActivities
            setLoading={setLoading}
            startEndObject={startEndObject}
          />
        </Col>
      </Row>
    </>
  );
};

export default SummaryList;
